import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VerbButton, { VERB_BUTTON_TYPE, FONT_AWESOME_ICON_WEIGHT } from './VerbButton';
import VerbDropdownMenu from './VerbDropdownMenu';

export { VERB_BUTTON_TYPE, FONT_AWESOME_ICON_WEIGHT };

class VerbDropdownButton extends Component {
    static propTypes = {
        type: PropTypes.string,
        buttonType: PropTypes.oneOf([
            VERB_BUTTON_TYPE.PRIMARY_DEFAULT,
            VERB_BUTTON_TYPE.PRIMARY_DETAILS,
            VERB_BUTTON_TYPE.SECONDARY_DEFAULT,
            VERB_BUTTON_TYPE.SECONDARY_DETAILS,
            VERB_BUTTON_TYPE.SECONDARY_DETAILS_SELECTED,
            VERB_BUTTON_TYPE.CRITICAL
        ]),
        onClick: PropTypes.func,
        className: PropTypes.string,
        menuClassName: PropTypes.string,
        fontAwesomeIcon: PropTypes.string,
        fontAwesomeIconWeight: PropTypes.oneOf([
            FONT_AWESOME_ICON_WEIGHT.SOLID,
            FONT_AWESOME_ICON_WEIGHT.REGULAR,
            FONT_AWESOME_ICON_WEIGHT.LIGHT
        ]),
        isDarkBackground: PropTypes.bool,
        buttonText: PropTypes.string,
        children: PropTypes.string,
        isSelected: PropTypes.bool,
        disabled: PropTypes.bool,
        dropdownHeader: PropTypes.string,
        dropdownData: PropTypes.arrayOf(
            PropTypes.shape({
                textId: PropTypes.string,
                text: PropTypes.string,
                icon: PropTypes.string,
                onClick: PropTypes.func,
                linkProps: PropTypes.object
            })
        ),
        popoverPlacement: PropTypes.string
    };

    render() {
        const { dropdownData, dropdownHeader, className, menuClassName, popoverPlacement, ...rest } = this.props;
        return (
            <VerbDropdownMenu
                dropdownData={dropdownData}
                dropdownHeader={dropdownHeader}
                className={menuClassName}
                popoverPlacement={popoverPlacement}
            >
                <VerbButton className={className} {...rest} />
            </VerbDropdownMenu>
        );
    }
}

export default VerbDropdownButton;
